import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export const BREAKPOINTS = {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600,
};

export const SIDER_WIDTH = 260;
export const SIDER_COLLAPSED_WIDTH = 72;

function useResponsive() {
    const screens = useBreakpoint();
    const isReady = Object.keys(screens).length > 0;
    const isMobile = isReady
        ? !screens.lg
        : window.innerWidth < BREAKPOINTS.lg;
    const isTablet = !!screens.md && !screens.lg;
    const isDesktop = isReady ? !!screens.lg : window.innerWidth >= BREAKPOINTS.lg;

    return {
        screens,
        isReady,
        isMobile,
        isTablet,
        isDesktop,
        siderWidth: SIDER_WIDTH,
        siderCollapsedWidth: isMobile ? 0 : SIDER_COLLAPSED_WIDTH,
    };
}

export default useResponsive;
